import * as firebase from "firebase/app";

export const firebaseFunctions = () => {
    if (false && window.location.hostname === 'localhost') {
        return firebase.functions();
    }

    return firebase.app().functions('europe-west1')
}